<template>
    <div class="message-composer">        
        <div v-if="showSubject">
            <input class="message-subject" type="text" v-model="subject" required placeholder="Enter subject here" />
        </div>
        <PostEditor ref="postEditor" v-bind="{
            content: null,
            cancel: this.cancel,
            submit: this.submit,
            allowAttachments: true,
            allowEditReason: false,
            allowMentions: false
        }"/>
    </div>
</template>

<script>

    import api from '../../api/api';
    import PostEditor from '../../components/Posts/PostEditor.vue'
    import dialogs from '../../modules/dialogs'

    export default {
        
        props: ['recipients', 'cancelled', 'submitted', 'showSubject', 'subject'],
        components: {
            PostEditor,
        },

        methods: {
            getContent() {
                return this.$refs.postEditor.getValue();
            },
            cancel() { 
                this.cancelled(); 
                this.subject = null;
                this.$refs.postEditor.setValue(null)    ;
            },
            submit(content, trackEditReason, editReason, done) {
                if (!this.validate()) return;
                api.post('/messages/send', {
                    recipientIDs: this.recipients,
                    content: content,
                    subject: this.subject
                }).then(() => {
                    done();
                    this.submitted();
                });                
            },
            validate() {
                if (!this.subject || this.subject.trim().length === 0) {
                    dialogs.alertAsync('Please add a subject to this message');
                    return false;
                }
                var content = this.getContent();
                if (!content || content.trim().length === 0) {
                    dialogs.alertAsync('Please enter a body for the message');
                    return false;
                }
                if (!this.recipients || this.recipients.length === 0) {
                    dialogs.alertAsync('Please select one or more recipients');
                    return false;
                }
                return true;
            }
        },
        mounted() {

        }
    }

</script>